import {DispatchHighLightAddressSearchEvent} from "../../util/events.ts";

export default function ConditionsSpecificAddressComponent(props: { show: boolean, setShow: (v: boolean) => void }) {
    return (
        <div className={`specific-address-popup ${props.show ? 'visible' : ''}`} onClick={() => props.setShow(false)}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <span className="close-popup wl-overlay__close" onClick={() => props.setShow(false)}>&times;</span>
                <h4 className="heading--montserrat">
                    Din adresse afgør, hvilken type internet og
                    hvilket kampagnetilbud du kan få
                </h4>
                <p>
                    Det afhænger nemlig af, hvilke kabler og hvilken netværksudbyder
                    der er tilsluttet din bolig. Det betyder at vi ikke kan garantere
                    aktuelle kampagnetilbud på alle adresser.
                </p>
                <h4 className="heading--montserrat">
                    Se hvad du kan få på din adresse
                </h4>
                <button
                    className={'button button--montserrat rounded'}
                    onClick={(e) => {
                        e.stopPropagation()
                        props.setShow(false)
                        DispatchHighLightAddressSearchEvent(true)
                    }}
                >
                    Tjek din adresse
                </button>
            </div>
        </div>
    )
}
